module.exports = __webpack_public_path__ + "pr.7477154a.svg";